import React from "react";
import { Input } from "@chakra-ui/react";
import { FieldWrapper } from "../../components/form/FieldWrapper";
import { NullableSwitch } from "../../components/form/NullableSwitch";
import { useDisabled, useNAState, isEmptyValue } from "../../utils/formField";

type Props = {
  field: any;
  value?: any;
  readOnly?: any;
  invalid?: boolean;
  submitted?: boolean;
};

const EmailField: React.FC<Props> = ({
  field,
  value = "",
  readOnly,
  invalid,
  submitted = false,
}) => {
  const nullable = field?.nullable === true;

  const { mode, setMode, text, setText } = useNAState({ value, nullable });
  const { ro, disabled } = useDisabled({ readOnly, nullable, mode });

  const requiredNow = !nullable || mode === "val";
  const derivedInvalid = !!invalid || (submitted && requiredNow && isEmptyValue(text));

  return (
    <FieldWrapper field={field} invalid={derivedInvalid}>
      <NullableSwitch
        nullable={nullable}
        mode={mode}
        setMode={setMode}
        readOnly={ro}
      >
        <Input
          name={!ro && requiredNow ? field.name : undefined}
          type="email"
          value={text}
          onChange={(e) => setText(e.target.value)}
          isDisabled={disabled}
          readOnly={ro}
          autoComplete="email"
          inputMode="email"
        />
      </NullableSwitch>

      {ro && (
        <input
          type="hidden"
          name={field.name}
          value={nullable ? (mode === "na" ? "N/A" : text) : text}
        />
      )}
      {!ro && nullable && mode === "na" && (
        <input type="hidden" name={field.name} value="N/A" />
      )}
    </FieldWrapper>
  );
};

export default EmailField;
